$(document).ready(korazonJS);
$(window).on('resize', korazonJS);

function korazonJS() {

    // Hide cookie panel if accept all
    $( ".accept-cookies" ).click(function() {
        $('.cookieconsent').fadeOut('slow');
    });

    // Show cookie options
    $( ".cookie-settings" ).click(function() {
        $('.cookieconsent-body-landing').hide();
        $('.cookieconsent-body-options').fadeIn('slow');
    });

    // Resize video content
    $(".wrapper-content").fitVids();

    $( ".row-items" ).each(function() {
        //var numItems = $('.referentie').length;
        var numItems = $(this).children('.referentie').length;
        //alert(numItems);
        $(this).addClass('column-' + numItems);
    });
    

    var $document = $(document),
            $element = $('#backTop');

            $( $element ).click(function() {
                $('body,html').animate({ scrollTop: 0 }, "slow");
                return false;
            });

        $document.scroll(function() {
            if ($document.scrollTop() >= 500) {
                $element.removeClass('masked');
            } else {
                $element.addClass('masked');
            }
        });

        $('#myTabReportage').tabCollapse();
        $('#myTabReportage').on('shown-accordion.bs.tabcollapse', function(){
            //alert('accordion is shown now, you can add an event !');
        });
        // Now, when a tab is clicked, always show active tab on top of page :::
        $(function () {
            $('#myTabReportage-accordion').on('shown.bs.collapse', function (e) {
                var offset = $('.panel.panel-default > .panel-collapse.in').offset();
                if(offset) {
                    $('html,body').animate({
                        scrollTop: $('#myTabReportage-accordion .panel-collapse.in').siblings('.panel-heading').offset().top
                    }, 0);
                }
            });
        });

    //Mobile

    if ($(window).width() < 1025) {

        //Init mobile layout
        $(".wrapper-hamburger").show();
        $("#mobile-nav-close").hide();

        if ($(".link-title").hasClass("active")) {
            $('.link-title.active').closest('.has-dropdown').addClass('open');
        }

        // Open mobile nav
        $( "#mobile-nav" ).click(function() {
          $(this).toggle();
          $("#mobile-nav-close").toggle();
          $(".nav-wrapper").addClass('open');
          $('body').addClass('fixed');

        });

        // Close mobile nav
        $( "#mobile-nav-close" ).click(function() {
          $(this).toggle();
          $("#mobile-nav").toggle();
          $(".nav-wrapper").removeClass('open');
          $('body').removeClass('fixed');
        });
        
        // Toggle sublinks  
        $( ".has-dropdown a.link-dropdown" ).click(function(event) {
            event.preventDefault();
            $(".has-dropdown").not(this.closest('.has-dropdown')).removeClass('open');
            $(this).closest('.has-dropdown').toggleClass('open');

        });

        
        if ($('.has-dropdown').hasClass('active')){
            $('.has-dropdown.active').addClass('open');
       }
          
        $( ".praktisch" ).insertAfter( ".event-detail h1" );

        


        // Hide Header on on scroll down

       
        
        var didScroll;
        var lastScrollTop = 0;
        var delta = 5;
        var navbarHeight = $('.header-mobile-wrapper').outerHeight();

        if(!$('body').hasClass('digitale-transformatie-toepassingen')){

            $(window).scroll(function(event){
                didScroll = true;
            });
    
            setInterval(function() {
                if (didScroll) {
                    hasScrolled();
                    didScroll = false;
                }
            }, 0);
    
            function hasScrolled() {
                var st = $(this).scrollTop();
                
                // Make sure they scroll more than delta
                if(Math.abs(lastScrollTop - st) <= delta)
                    return;
                
                // If they scrolled down and are past the navbar, add class .nav-up.
                if (st > lastScrollTop && st > navbarHeight){
                    // Scroll Down
                    //$('.header-mobile-wrapper').removeClass('nav-down').addClass('nav-up');
                    $('.header-mobile-wrapper').removeClass('fixed');
                } else {
                    // Scroll Up
                    if ($(window).scrollTop() < 85){
                      //$('.header-mobile-wrapper').removeClass('nav-down');
                      $('.header-mobile-wrapper').removeClass('fixed');
                    }
                    else if(st + $(window).height() < $(document).height()) {
                        //$('.header-mobile-wrapper').removeClass('nav-up').addClass('nav-down');
                        $('.header-mobile-wrapper').addClass('fixed');
                    }
                }
                
                lastScrollTop = st;
              
            }
            
        }

        

        

        /*
        
        $(window).bind('scroll', function() {
            var navHeight = $( window ).height() - 0;
                  if ($(window).scrollTop() > navHeight) {
                      $('.header-mobile-wrapper').addClass('fixed');
                  }
                  else {
                      $('.header-mobile-wrapper').removeClass('fixed');
                  }
             });

             */

             /*

             $(window).bind('scroll', function () {
                if ($(window).scrollTop() > 100) {
                    $('.header-mobile-wrapper').addClass('fixed');
                }
                else
                {
                    $('.header-mobile-wrapper').removeClass('fixed');
                }
                });


                */

                
        
        
    }

    // Desktop

    else{

        //Init desktop layout
        $(".nav-wrapper").removeClass('open');
        $(".wrapper-hamburger").hide();
        $("body").css({
          "height": "auto",
          "overflow": "visible"
        });
        

        // Show subnav dropdown
        $(".has-dropdown").mouseenter(function(){
            $(this).addClass('open');
        });

        

        // Remove subnav dropdown
        $(".has-dropdown").mouseleave(function(){
            $(this).removeClass('open');
        });

        

        if($('.inschrijven').length){
            $( ".praktisch" ).insertBefore( ".inschrijven" );
        }
        else{
            $( ".praktisch" ).insertBefore( ".gmaps" );
        }


        $(".row-items").each(function(){ 

            var largest = 0;
          
            $(this).find(".referentie .header aside").each(function(){
               var findHeight = $(this).height();
               if(findHeight > largest){
                  largest = findHeight;
               }  
            });
          
            $(this).find(".referentie .header aside").css({"height":largest+"px"}); 
          });

    }

}